<div class="pt-4 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage this inbox.</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-6">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Unlinked Memberships
        <span *ngIf="unlinkedCustomerInboxItems">({{ unlinkedCustomerInboxItems.length }})</span>
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Purchase Date</th>
        <th scope="col">Customer Name</th>
        <th scope="col">Membership Name</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingUnlinkedCustomerInboxItems && inboxItemsPresent()">
      <tr *ngFor="let unlinkedCustomerInboxItem of unlinkedCustomerInboxItems">
        <td>
          {{ dateStringFromISO8601(unlinkedCustomerInboxItem.purchased_at) }}
        </td>
        <td>{{ unlinkedCustomerInboxItem.first_name }} {{ unlinkedCustomerInboxItem.last_name }}</td>
        <td>{{ unlinkedCustomerInboxItem.membership_name }}</td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openReviewUnlinkedMembershipCustomerModal(unlinkedCustomerInboxItem);$event.preventDefault();">
            Review
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingUnlinkedCustomerInboxItems || !inboxItemsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingUnlinkedCustomerInboxItems">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingUnlinkedCustomerInboxItems && !inboxItemsPresent()">
          No outstanding unlinked memberships.
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
